module.exports = __webpack_public_path__ + "static/kroger-intro-img-03-060c404d50c27859cc187d26c7f6e133.png";